module.exports = __webpack_public_path__ + "img/index-3-pic04@2x.9483e32b.png";